

export const index = 14;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/(internal)/create/project/thankyou/__uuid__/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/14.gAFgMEnF.js","_app/immutable/chunks/scheduler.DHUbek42.js","_app/immutable/chunks/index.ClBRh6_e.js","_app/immutable/chunks/stores.mpbHtACE.js","_app/immutable/chunks/entry.BkyxWuP6.js","_app/immutable/chunks/index.gpef7426.js","_app/immutable/chunks/PageLayout.Dn93WDpj.js","_app/immutable/chunks/CheckCircleOutline.BvXpwY5Y.js","_app/immutable/chunks/spread.CgU5AtxT.js","_app/immutable/chunks/tw-merge.Ds6tgvmq.js"];
export const stylesheets = [];
export const fonts = [];
